'use client'

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { useNotificationsStore } from './use-notifications-store'

interface ComparisonState {
  productIds: string[]
  addProduct: (id: string) => void
  removeProduct: (id: string) => void
  clearComparison: () => void
  isComparing: (id: string) => boolean
}

const MAX_COMPARISON_ITEMS = 4

export const useComparisonStore = create<ComparisonState>()(
  persist(
    (set, get) => ({
      productIds: [],

      addProduct: (id: string) => {
        set((state) => {
          if (state.productIds.includes(id)) return state
          if (state.productIds.length >= MAX_COMPARISON_ITEMS) return state
          return { productIds: [...state.productIds, id] }
        })
        try {
          const currentIds = get().productIds
          if (currentIds.includes(id)) {
            useNotificationsStore.getState().addNotification({
              type: 'success',
              title: 'Добавлено в сравнение',
            })
          } else if (currentIds.length >= MAX_COMPARISON_ITEMS) {
            useNotificationsStore.getState().addNotification({
              type: 'warning',
              title: 'Можно сравнивать не более 4 товаров',
              message: 'Удалите товар из сравнения, чтобы добавить новый',
            })
          }
        } catch { /* ignore */ }
      },

      removeProduct: (id: string) => {
        set((state) => ({
          productIds: state.productIds.filter((productId) => productId !== id),
        }))
      },

      clearComparison: () => {
        set({ productIds: [] })
      },

      isComparing: (id: string) => {
        return get().productIds.includes(id)
      },
    }),
    {
      name: 'dveriant-comparison',
      partialize: (state) => ({ productIds: state.productIds }),
    },
  ),
)
